getFirstLiveStreamSession